export default __webpack_public_path__ + "static/media/move_open.454c528e.svg";